// extracted by mini-css-extract-plugin
module.exports = {"Hero":"Entertainment_Hero__AYIx3","books_image":"Entertainment_books_image__377D5","cardAnimation":"Entertainment_cardAnimation__1y7iI"};